import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { DropdownOption } from '../../../../../common/components/PrimarySelect/PrimarySelect';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';
import './DialogueSelectorWithReload.pcss';
import { DialogueSelectForm } from '../../../campaigns/components/DialogueSelectForm/DialogueSelectForm';
import { successToast } from '../../../../../common/helpers/toast';

type Props = {
  dialogueId: number;
  className?: string;
  label?: string;
  disabled?: boolean;
  forCampaign?: boolean;
  forFacebook?: boolean;
  entityUpdateFunction: (dialogueId: number) => Promise<
    | {
        newDialogueId: number;
        newUrl?: string;
      }
    | undefined
  >;
};

export const DialogueSelectorWithReload = ({
  dialogueId,
  className,
  label = 'Dialogue:',
  entityUpdateFunction,
  forCampaign = false,
  forFacebook = false,
  disabled = false,
}: Props) => {
  const modalActions = useModalActions();
  const dialogues = useSelector((state: StoreState) => state.page.entities);
  const selectedDialogue = dialogues.find(d => d.id === dialogueId);

  const widgetCRUDActions = useWidgetCRUDActions();
  const { history } = useRouter();

  const classList = classnames('reloading-dialogue-selector', className);

  const updateDialogue = async (option: DropdownOption) => {
    const numericDialogueId = Number(option.id);
    if (numericDialogueId && numericDialogueId !== dialogueId) {
      const payload = await entityUpdateFunction(numericDialogueId);

      if (payload) {
        const { newDialogueId, newUrl } = payload;

        if (newDialogueId) {
          await widgetCRUDActions.retrieveAll(newDialogueId, true);
          newUrl && history.replace(newUrl);
        }
      }
    }
  };

  const handleDialogueSelect = () => {
    modalActions.openDialoguePickerNewModal({
      withNoOption: false,
      selectedDialogueId: selectedDialogue?.id,
      onDialogueSelected: (_, dialogue) => {
        updateDialogue(dialogue as DropdownOption);
        successToast('Dialogue updated');
      },
    });
  };

  // TODO deprecate?
  // modalActions.openDialogueSettingsModal(dialogueId);
  return (
    <DialogueSelectForm
      className={classList}
      dialogueId={selectedDialogue?.id}
      dialogueName={selectedDialogue?.name}
      disabled={disabled}
      label={label}
      onChangeClick={handleDialogueSelect}
      onCreateClick={handleDialogueSelect}
    />
  );
};
